
const initialState = {
    savedToBlock: false,
    offerDetails: {},
    receiptStatus: null,
    updateReceiptStatus: null,
    transactions: null,
    validations: null
}

export const block = {
    namespaced: true,
    state: initialState,
    actions: {
        saved({ commit }) {
            commit('savedToBlock')
        },
        handleOffer({ commit }, offer) {
            commit('savedOffer', offer)
        },
        resetSave({ commit }) {
            commit('resetSave')
        },
        saveTransactions({ commit }, transaction) {
            commit('saveTransactions', transaction)
        },
        saveValidations({ commit }, validation) {
            commit('saveValidations', validation)
        }
    },
    mutations: {
        change(state, saveToBlock) {
            state.savedToBlock = saveToBlock;
        },
        offerSuccess(state, offer) {
            state.savedToBlock = true;
            state.offer = offer
        },
        resetSave(state) {
            state.savedToBlock = false
        },
        receipt(state, status) {
            state.receiptStatus = status
        },
        updateReceipt(state, status) {
            state.updateReceiptStatus = status
        },
        saveT(state, transactions) {
            state.transactions = transactions
        },
        saveV(state, validations) {
            state.validations = validations
        }
    },
    getters: {
        getTransactions: state => state.transactions,
        getValidations: state => state.validations
    }
};